import { useContext } from "@nuxtjs/composition-api";

export const getPromos = (promosData) => promosData.value.data?.promotions || {};

export const getPromo = (promoData) => promoData.value.data?.promotions?.items[0] || {};

export const getId = (promo) => (promo ? promo.item_id : "");

export const getTitle = (promo) => (promo && !promo.label ? promo.title : promo.label);

export const getUrl = (promo) => (promo ? promo.url_key : "");

export const getDate = (promoDate) => {
  if (!promoDate) return "";

  const { app } = useContext();

  const date = new Date(promoDate);

  return date.toLocaleDateString(app.i18n.localeProperties.iso, {
    month: "long",
    year: "numeric",
    day: "numeric",
  });
};

export const getImage = (promo) => (promo && promo.image_url && !promo.listing_image_desktop_url ? promo.image_url : promo.listing_image_desktop_url);

const promoGetters = {
  getPromos,
  getPromo,
  getId,
  getTitle,
  getUrl,
  getImage,
  getDate,
};

export default promoGetters;
